import React from 'react';
import { FormComponentValue } from 'components/common/form/layout/control';
import { ReactSelectOption } from 'components/common/react-select/parts/ReactSelectOption';
import { ReactSelectSingleValue } from 'components/common/react-select/parts/ReactSelectSingleValue';
import { ReactSelectMultiValue } from 'components/common/react-select/parts/ReactSelectMultiValue';
import ResourceStateChip from './ResourceStateChip';

// Only an explicit false counts: options from a backend that predates the verdict, or from other
// callers, carry no `published` key and render as before.
export function isUnpublished(option: FormComponentValue | undefined): boolean {
    return false === option?.props?.published;
}

export function isDeleted(option: FormComponentValue | undefined): boolean {
    return true === option?.props?.deleted;
}

function withChip(props: any) {
    const state = isDeleted(props.data) ? 'deleted' : isUnpublished(props.data) ? 'unpublished' : null;
    if (null === state) return props.children;
    return (
        <>
            {props.children}
            <ResourceStateChip state={state} />
        </>
    );
}

export const ResourceOption = (props: any) => <ReactSelectOption {...props} children={withChip(props)} />;
export const ResourceSingleValue = (props: any) => <ReactSelectSingleValue {...props} children={withChip(props)} />;
export const ResourceMultiValue = (props: any) => <ReactSelectMultiValue {...props} children={withChip(props)} />;
